import { Directive } from '@angular/core';

@Directive({
  selector: '[crmPageActions], crm-page-actions',
  standalone: true,
})
export class PageActionsDirective {}
